import {findAll, onReady} from "../../../../modules/vegas/js/util";
import {VGSelect} from "vgselect";

function initSelect() {
	[...findAll('.vg-select')].forEach((element) => {
		new VGSelect(element, {})
	});
}

onReady(initSelect);
typeof onTurboRender !== 'undefined' && onTurboRender(initSelect);
